// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"229":"ec7e1d74","906":"01816611"}[chunkId] + ".js";
};